import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import useFavorites from "@/hooks/useFavorites";
import { actresses } from "@/mocks/actresses";

export default function FavoritesMenu() {
  const { favorites } = useFavorites();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const saved = favorites
    .map((id) => actresses.find((item) => item.id === id))
    .filter((item): item is (typeof actresses)[number] => Boolean(item));

  return (
    <div ref={wrapRef} className="relative">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
        className="flex h-10 cursor-pointer items-center gap-1.5 rounded-full border border-background-300 bg-background-50 px-3 font-label text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
      >
        <i className="ri-heart-3-line text-base" aria-hidden="true"></i>
        收藏
        <span className="flex h-5 min-w-5 items-center justify-center rounded-full bg-primary-500 px-1 text-[10px] text-background-50">
          {saved.length}
        </span>
      </button>

      {open ? (
        <div className="absolute right-0 top-full z-50 mt-2 w-[300px] rounded-lg border border-background-200 bg-background-50 p-3">
          <p className="px-1 pb-2 font-label text-xs text-foreground-500">
            我的收藏
            <span className="ml-1 text-foreground-400">（本地演示，仅保存在当前浏览器）</span>
          </p>
          {saved.length > 0 ? (
            <ul className="space-y-1">
              {saved.map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/detail/actress/${item.id}`}
                    onClick={() => setOpen(false)}
                    className="flex items-center gap-2 rounded-md px-2 py-2 transition-colors hover:bg-primary-50"
                  >
                    <span className="h-9 w-9 shrink-0 overflow-hidden rounded-full bg-background-200">
                      <img
                        src={item.portrait}
                        alt={`${item.name} 女优资料写真`}
                        title={`${item.name} 日本女优资料`}
                        className="h-full w-full object-cover object-top"
                      />
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block truncate font-label text-sm text-foreground-900">{item.name}</span>
                      <span className="block truncate font-label text-[11px] text-foreground-500">
                        {item.agency} · {item.worksCount} 部作品
                      </span>
                    </span>
                    <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true"></i>
                  </Link>
                </li>
              ))}
            </ul>
          ) : (
            <div className="rounded-md bg-background-100 px-3 py-6 text-center">
              <i className="ri-heart-3-line text-xl text-foreground-300" aria-hidden="true"></i>
              <p className="mt-1 font-label text-xs text-foreground-600">还没有收藏的女优</p>
              <Link
                to="/category"
                onClick={() => setOpen(false)}
                className="mt-1 inline-block font-label text-xs text-primary-700 underline underline-offset-2"
              >
                去分类页看看
              </Link>
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
}